<template>
  <div class="sns-official-section">
    <!-- TODO: SFGO-xxx ホーム画面にシーンコメント追加 実装時にマスクを解除する -->
    <highlights-comment-trigger-parts
      v-if="false"
      :highlightTrigger="highlightTrigger"
      @click="changeHighlightsTrigger"
    />

    <template v-if="!isUseDynamicScroller">
      <div class="sns-official-section__posts">
        <sns-post-item-parts
          class="sns-official-section__posts__item"
          v-for="post in snsContentsData"
          :key="`${post.link}`"
          :snsPost="post"
        />
      </div>
    </template>
    <template v-else>
      <dynamic-scroller
        class="sns-official-section__posts"
        :class="{ 'sns-official-section__posts__isApp': isUseDynamicScroller }"
        :items="snsContentsData"
        :min-item-size="68"
        key-field="link"
      >
        <template v-slot="{ item, index, active }">
          <dynamic-scroller-item
            :item="item"
            :active="active"
            :data-index="index"
            :sizeDependencies="[item.post, item.images, item.highlightComment]"
            :watchData="true"
          >
            <sns-post-item-parts
              class="sns-official-section__posts__isApp__item"
              :class="{ 'sns-official-section__posts__isApp__item--first': index === 0 }"
              :snsPost="item"
              @updateSnsContentsData="updateSnsContentsData"
            />
          </dynamic-scroller-item>
        </template>
      </dynamic-scroller>
    </template>

    <sns-post-loader-parts v-if="snsLoading" />
  </div>
</template>

<script lang="ts">
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { defineComponent, onMounted, ref, watch, Ref } from '@vue/composition-api'
import SnsPostItemParts from '@/components/HomePage/HomePane/parts/SnsPostItemParts.vue'
import SnsPostLoaderParts from '@/components/HomePage/HomePane/parts/SnsPostLoaderParts.vue'
import StoreUtil from '@/store/StoreUtil'
import HighlightsCommentTriggerParts from '@/components/HomePage/HomePane/parts/HighlightsCommentTriggerParts.vue'
import { SnsPostData } from '@/store/stores/pageStore/HomePage/HomePageStore'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * HOME SNS 公式コンテンツセクション
 */
export default defineComponent({
  name: 'SnsOfficialSection',
  components: {
    HighlightsCommentTriggerParts,
    SnsPostItemParts,
    SnsPostLoaderParts,
  },
  setup() {
    const store = StoreUtil.useStore('HomePageStore')
    const errorImgSrc = ref('')
    /**
     * アプリ版のAndroidのみvue-virtual-scroller（DynamicScroller）を導入する
     */
    const isUseDynamicScroller = DeviceInfo.isAndroid()

    onMounted(() => {
      // SF公式アカウントのSNS投稿を取得する
      store.fetchHomePageSnsFeed('SF')
    })

    /**
     * SF公式アカウントのSNS記事データ
     */
    const snsContentsData = ref([]) as Ref<SnsPostData[]>

    /**
     * store.getSnsFeedDataListの変更を監視し、リアクティブにデータを作成する
     */
    watch(
      () => store.getSnsFeedDataList.value,
      (newData) => {
        snsContentsData.value = newData.map((obj) => ({
          ...obj,
          images: obj.images.filter((image) => image.src !== errorImgSrc.value),
        }))
      },
      {
        immediate: true,
        deep: true,
      },
    )

    /**
     * SNSコンテンツローディング中フラグ
     */
    const snsLoading = ref<boolean>(false)

    /**
     * ハイライトのみ絞り込みフィルター
     */
    const highlightTrigger = ref<boolean>(false)

    /**
     * imgタグで読み込みエラーになったデータを削除して、データを再構築する
     * この処理によってdynamic-scrollerで再計算が行われる
     */
    const updateSnsContentsData = (src: string) => {
      errorImgSrc.value = src
      snsContentsData.value = snsContentsData.value.map((obj) => ({
        ...obj,
        images: obj.images.filter((image) => image.src !== src),
      }))
    }

    return {
      snsContentsData,
      snsLoading,
      highlightTrigger,
      updateSnsContentsData,
      isUseDynamicScroller,
    }
  },
  methods: {
    /**
     * ハイライトコメントフィルター切替
     */
    changeHighlightsTrigger() {
      // TODO: 絞り込み処理
      this.highlightTrigger = !this.highlightTrigger
    },
  },
})
</script>

<style lang="scss" scoped>
.sns-official-section {
  width: 100%;

  &__posts {
    display: flex;
    flex-flow: column nowrap;
    align-content: flex-start;
    justify-items: flex-start;
    width: calc(100% - 32px);
    margin: 0 auto;
    gap: 1px;
    background: $white;
    border-radius: min(#{convertPXtoVW(8), 8px});
    border: 1px solid $black10;
    overflow: hidden;

    &__isApp {
      max-height: $snsContentHeight;

      &__item {
        &:not(&--first) {
          border-top: 1px solid $black05;
        }
      }
    }

    &__item {
      &:not(:first-child) {
        border-top: 1px solid $black05;
      }
    }
  }
}
</style>
